import { PageParam } from '@/models/common';
import { trueFilter } from '@/utils/common';
import React, { useEffect, useState } from 'react';
import { useImmer } from 'use-immer';
import { ID } from '../../../global'; // e.g. type ID = string | number;
import { SelectorProps } from './createModalSelector';
import { DataSource } from './datasource';

// ------------------ 主组件工厂 ------------------
export const createFieldViewer = <T extends object, FilterValue extends object = {}>({
  datasource,
  title: factoryTitle = '选择器',
}: {
  datasource: DataSource<T>;
  title?: React.ReactNode;
}) => {
  return function SelectorComponent(
    props: Omit<SelectorProps<T>, 'value'> & {
      value: ID | ID[];
    }
  ) {
    const { onCancel, selectStyle, selectClassName, dataFilter = trueFilter, open, title, value } = props;
    const [dataList, setDataList] = useState<T[]>();
    const [loading, setLoading] = useState(false);
    const [queryInfo, updateQueryInfo] = useImmer<{ pageParam: PageParam; filter: FilterValue }>({
      pageParam: { current: 1, pageSize: 10 },
      filter: {} as FilterValue,
    });

    const loadData = () => {
      setLoading(true);
      var valueArr = Array.isArray(value) ? value : [value];
      datasource
        .getViewList({
          pageParam: queryInfo.pageParam,
          filter: queryInfo.filter,
          value: valueArr,
        })
        .then(list => {
          const filtered = list.filter(dataFilter);
          setDataList(filtered);
        })
        .finally(() => setLoading(false));
    };

    useEffect(() => {
      loadData();
    }, []);

    return (
      <>
        {(dataList || []).map(v => {
          return <React.Fragment key={datasource.getKey(v)}>{datasource.getLabel(v)}</React.Fragment>;
        })}
      </>
    );
  };
};
